<pos-app-spinner [show]="loading"></pos-app-spinner>
<div class="pb-5">
  <div class="text-center">
    <h3 class="pt-3 arb-large-heading">CLOSED ARB ORDERS</h3>
  </div>
  <div class="col pt-2 mx-4">  <div class="pt-2 mx-4">
    <div class="col-2 pb-2 w-20 d-flex justify-content-end">
      <input type="text" class="form-control" placeholder="Filter Order" />
    </div>
    <ag-grid-angular
      #agGrid
      class="ag-theme-balham datagrid"
      [rowData]="[]"
      [context]="context"
      [frameworkComponents]="frameworkComponents"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      [domLayout]="'autoHeight'"
      [pagination]="true"
      [paginationPageSize]="20"
    ></ag-grid-angular>
  </div>
</div>
